export const FLOW_TYPES = {
  UNSUBSCRIBE: "UNSUBSCRIBE",
  SUBSCRIBE: "SUBSCRIBE",
  OPT_OUT: "MERCHANT_OPT_OUT",
  OPT_IN: "OPT_IN",
};